export default __webpack_public_path__ + "static/media/video-placeholder-viloet.897ca104.png";